"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.removeItem = exports.removeItemFromAll = exports.removeItemFromCookies = exports.removeItemFromLocalStorage = void 0;
var _localStorage = _interopRequireDefault(require("store/storages/localStorage"));
var _cookieStorage = _interopRequireDefault(require("store/storages/cookieStorage"));
var _clientStorage = require("../../constants/clientStorage");

/**
 * remove item from local storage
 */
var removeItemFromLocalStorage = function removeItemFromLocalStorage(key) {
  try {
    _localStorage.default.remove(key);
  } catch (err) {// ...do nothing
  }
};
/**
 * remove item from cookies
 */

exports.removeItemFromLocalStorage = removeItemFromLocalStorage;
var removeItemFromCookies = function removeItemFromCookies(key) {
  return _cookieStorage.default.remove(key);
};
/**
 * Remove an item from all supported storage types
 */

exports.removeItemFromCookies = removeItemFromCookies;
var removeItemFromAll = function removeItemFromAll(key) {
  // remove the item from localStorage
  removeItemFromLocalStorage(key); // remove item from cookies

  removeItemFromCookies(key);
};
exports.removeItemFromAll = removeItemFromAll;
var removeItem = function removeItem(key) {
  var clientStorageType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _clientStorage.CLIENT_STORAGE_LOCAL_STORAGE;
  switch (clientStorageType) {
    case _clientStorage.CLIENT_STORAGE_COOKIES:
      return removeItemFromCookies(key);
    case _clientStorage.CLIENT_STORAGE_LOCAL_STORAGE:
      return removeItemFromLocalStorage(key);
    case _clientStorage.CLIENT_STORAGE_ALL:
    default:
      return removeItemFromAll(key);
  }
};
exports.removeItem = removeItem;
var _default = removeItem;
exports.default = _default;